<template>
  <div class="container pt-mb-5 pt-3 mb-sm-5 mb-3">
    <div class="dashboard">
      <div class="row mt-5">
        <div class="col-lg-3 col-md-4 mb-5">
          <div class="sidebar">
            <a href="#"><h3 class="ser-vis-head dasssh">Dashboard</h3></a>
            <ul>
              <li>
                <a :href="myProfileRoute" class="hover-color"><img :src="image1" class="iamgdd1" />User Profile</a>
              </li>
              <li>
                <a :href="petData" class="hover-color"><img :src="image2" class="iamgdd1" />My Pets</a>
              </li>
              <li class="prof-3">
                <a href="" class="my_booking hover-color"><img :src="image3" class="iamgdd1" />My Bookings</a>
              </li>
              <li>
                <a :href="myReward" class="hover-color"> <img :src="image3" class="iamgdd1" />My Rewards</a>
              </li>
              <li>
                <a :href="logoutRoute" class="hover-color"><img :src="image4" class="iamgdd1" />Logout</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9 col-md-8 mb-5">
          <h5 class="my_booking_head">My Bookings</h5>
          <div class="main-content">
            <table class="table table_resposive">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Booking Type</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">Pet</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Status</th>
                  <th scope="col">Payment Status</th>
                  <th scope="col">View</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(booking, index) in paginatedData" :key="index">
                  <th scope="row">{{ index + 1 + (currentPage - 1) * perPage }}</th>
                  <td>{{ ucfirst(booking.booking_type || '') }}</td>
                  <td>{{ booking.start_date_time }}</td>
                  <!-- <td>{{ booking.pet?.name }}</td> -->
                  <td>
                    <template v-if="booking.pet">
                      {{ booking.pet.name }}
                    </template>
                    <template v-else-if="booking.pets && booking.pets.length">
                      <span v-for="(pet, index) in booking.pets" :key="pet.id">
                        {{ pet.name }}<span v-if="index !== booking.pets.length - 1">, </span>
                      </span>
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td>{{ booking.total_amount }}</td>
                  <td>
                    <span v-if="booking?.status === 'pending'" class="text-capitalize badge bg-soft-warning p-3">Pending</span>
                    <span v-else-if="booking?.status === 'confirmed'" class="text-capitalize badge bg-soft-success p-3">Confirmed</span>
                    <span v-else-if="booking?.status === 'cancelled'" class="text-capitalize badge bg-soft-danger p-3">Cancelled</span>
                    <span v-else-if="booking?.status === 'in_progress'" class="text-capitalize badge bg-soft-primary p-3">In Progress</span>
                    <span v-else-if="booking?.status === 'completed'" class="text-capitalize badge bg-soft-info p-3">Completed</span>
                    <span v-else-if="booking?.status === 'rejected'" class="text-capitalize badge bg-soft-danger p-3">Rejected</span>
                    <span v-else class="text-capitalize badge bg-soft-secondary p-3">Unknown</span>
                  </td>
                  <td>
                    <span v-if="booking.payment?.payment_status === 1" class="text-capitalize badge bg-soft-info p-3">Paid</span>
                    <span v-else class="text-capitalize badge bg-soft-warning p-3" name="payment-status-{{ booking.payment?.payment_status }}">Pending</span>
                  </td>

                  <td style="display: flex;align-items: center;gap: 5px;" class="py-4">
                    <a v-if="booking.booking_type === 'boarding'" :href="`/view-media/${booking.id}`" target="_blank" class="icon-view bg-success p-2 rounded">
                        <i class="fas fa-images text-white"></i>
                    </a>
                    <a :href="`/booking-bill/${booking.id}`" target="_blank" class="icon-view bg-danger p-2 rounded">
                      <i class="fas fa-file-pdf text-white"></i>
                    </a>
                    <button @click="cancelBooking(booking.id)" class="btn btn-sm btn-danger">Cancel</button>
                    <!-- <a href="#" class="icon-download bg-danger p-2 rounded"><i class="fas fa-download text-white"></i></a> -->
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination Controls -->
            <div class="pagination-controls">
              <button @click="prevPage" :disabled="currentPage === 1">Previous</button>
              <span>Page {{ currentPage }} of {{ totalPages }}</span>
              <button @click="nextPage" :disabled="currentPage === totalPages">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="spring-img">
    <img :src="image1" />
  </div>

  <div class="spring-img-2">
    <img :src="image2" />
  </div> -->
</template>

<script setup>
import axios from 'axios';
import { ref, computed } from 'vue';



const { bookingsData, petData, logoutRoute, myProfileRoute, image1, image2,image3,image4, myReward } = defineProps(['bookingsData', 'petData', 'logoutRoute', 'myProfileRoute', 'image1', 'image2','image3','image4', 'myReward'])

const currentPage = ref(1)
const perPage = ref(10)

const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * perPage.value
  const end = start + perPage.value
  return bookingsData.slice(start, end)
})

const totalPages = computed(() => {
  return Math.ceil(bookingsData.length / perPage.value)
})

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
  }
}

const ucfirst = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
const cancelBooking = async (bookingId) => {
  try {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you really want to cancel this booking?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, cancel it!',
      cancelButtonText: 'No, keep it'
    });

    if (result.isConfirmed) {
      const response = await axios.post('/cancel_booking', {
        booking_id: bookingId,
        status: 'cancelled'
      });

      if (response.data.success) {
        Swal.fire({
          title: 'Cancelled!',
          text: 'Your booking has been cancelled.',
          icon: 'success',
          confirmButtonColor: '#3085d6'
        }).then(() => {
          location.reload();
        });
      } else {
        Swal.fire({
          title: 'Failed!',
          text: 'Failed to cancel the booking.',
          icon: 'error',
          confirmButtonColor: '#3085d6'
        });
      }
    }
  } catch (error) {
    Swal.fire({
      title: 'Error!',
      text: 'An error occurred while cancelling the booking.',
      icon: 'error',
      confirmButtonColor: '#3085d6'
    });
  }
}


</script>

<style scoped>
/* .dashboard {
  display: flex;
  margin: 0 auto;
} */

 .table>:not(:last-child)>:last-child>*{
  white-space: normal;
 }

.sidebar {
  max-width: 100%;
  padding: 20px;
  top: 48px;
  border-radius: 10px;
  position: static;
  box-shadow: none !important;
  background: #f8f8f8;
}

.sidebar h2 {
  margin-bottom: 20px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar ul li {
  margin-bottom: 10px;
  padding: 10px 15px;
}

.sidebar ul li a {
  text-decoration: none;
  color: #2e2928;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

/* .sidebar ul li a:hover {
  color: #bf360c;
} */

.main-content {
  flex: 1;
  /* padding: 20px; */
  margin-left: 0px !important;
  background-color: white;
  border-radius: 10px;
  /* margin-top: 40px; */
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  border: 1px solid #ececec;
}

.stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stat-card {
  flex: 1;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
}

.order-list {
  list-style: none;
  padding: 0;
}

.order-list li {
  margin-bottom: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}
.clos-btn {
  color: #000;
  background-color: #ffff !important;
  border-radius: 10px;
}

.add-new-btns {
  color: black;
  background: transparent;
}
.add-new-btns:hover {
  color: white;
  background-color: #bf360c;
}

.my_booking {
  color: #bf360c !important;
}

.my_booking_head {
  font-size: 20px;
  font-weight: 600;
  color: #2e2928;
  margin-bottom: 20px;
  /* border-bottom: 1px dashed #bf360c; */
  /* padding-bottom: 20px; */
}

.web-bg {
  position: relative;
}

.spring-img {
  position: absolute;
  bottom: 20px;
  left: -40px;
}

.spring-img img {
  width: 150px;
}

.spring-img-2 img {
  width: 130px;
}

.spring-img-2 {
  position: absolute;
  top: 30px;
  right: 0;
}

.sidebar ul li a.active {
  color: #bf360c !important;
}

.iamgdd1 {
  width: 30px;
  margin-right: 10px;
}

.sidebar ul li:hover {
  background-color: #f9ede8;
  border-radius: 20px;
}
.prof-3 {
  background-color: #f9ede8 !important;
  border-radius: 20px;
  margin-bottom: 10px;
}
.sidebar ul li:hover .hover-color {
  color: #bf360c !important;
}

.middle {
  border-bottom: 1px dashed #ececec !important;
}
.table tbody tr td {
  border-bottom: 1px dashed #ececec !important;
}
.table_resposive {
  border-radius: 10px 10px 0px 0px;
}

/* media css */

@media screen and (max-width: 1600px) {
  .spring-img-2 img {
    display: none;
  }
  .spring-img img {
    display: none;
  }
}

@media screen and (max-width: 1199px) {
  /* .sidebar {
    height: 250px;
  } */
}
@media screen and (max-width: 991px) {
  .table_resposive {
    display: block;
    width: 100%;
    overflow-x: auto;
  }
}

@media screen and (max-width: 767px) {
  .web-bg .sidebar {
    height: auto !important;
  }
  .web-bg .main-content {
    margin-top: 20px;
  }
}

.pagination-controls {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

.pagination-controls button {
  margin: 0 10px;
}
</style>
